/** Fixed recovery copy for the controlled priority command; never echo database details. */
const PRIORITY_REFUSALS = {
  incident_p1_priority_downgrade_not_permitted:
    'Recorded facts meet the Priority 1 rule. Correct a disputed fact with a reason before recording Priority 2.',
  incident_sirs_override_justification_required:
    'Record a justification before saving the SIRS priority.',
  incident_sirs_override_requires_reportable_incident:
    'Record the incident’s SIRS reportability decision before choosing its priority.',
  incident_sirs_override_required_arg_missing:
    'Reopen the incident and choose Priority 1 or Priority 2 before saving.',
  incident_sirs_priority_override_role_required:
    'Ask an authorised clinical or quality lead to review the SIRS priority.',
  incident_not_found: 'This incident is no longer available. Refresh the incident register.',
} as const;

export function incidentPriorityRefusal(error: unknown): { code: string; message: string } | null {
  if (typeof error !== 'object' || error === null) return null;
  for (const key of ['code', 'message']) {
    const property = Object.getOwnPropertyDescriptor(error, key);
    const value: unknown = property && 'value' in property ? property.value : undefined;
    if (typeof value !== 'string' || value.length > 4096) continue;
    const token = value.trim().split(':', 1)[0] ?? '';
    if (Object.hasOwn(PRIORITY_REFUSALS, token)) {
      return { code: token, message: PRIORITY_REFUSALS[token as keyof typeof PRIORITY_REFUSALS] };
    }
  }
  return null;
}
